export default __webpack_public_path__ + "static/media/ran.1f222481.jpg";